import { VariaveisAmbiente } from 'config';
import { PessoaInfoModel } from 'model/api/gestao/pessoa/pessoa-info-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePutAtualizarPessoaInfo() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putAtualizarPessoaInfo = useCallback(
        (info: PessoaInfoModel, pessoaId: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Pessoa/${pessoaId}/info`,
                method: 'PUT',
                data: info,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putAtualizarPessoaInfo,
    };
}
